module.exports = __webpack_public_path__ + "media/customizations/paintedtree/logo-new-ec6d9abb9200e1a3565bb79a5e2da4d1.png";